var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2309 18.5653C11.2309 22.7425 14.6172 26.129 18.7945 26.129C22.9716 26.129 26.3582 22.7425 26.3582 18.5653C26.3582 14.3882 22.9718 11.0017 18.7945 11.0017C14.6172 11.0017 11.2309 14.3882 11.2309 18.5653Z",
    fill: "#FCDB7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7943 8.25124C19.3006 8.25124 19.7112 7.84502 19.7112 7.34578V0.905468C19.7112 0.403379 19.3006 0 18.7943 0C18.2878 0 17.8776 0.403379 17.8776 0.905468V7.34578C17.8776 7.84502 18.288 8.25124 18.7943 8.25124Z",
    fill: "#FCDB7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7943 37.3599C19.3006 37.3599 19.7112 36.9546 19.7112 36.4547V30.014C19.7112 29.512 19.3006 29.1086 18.7943 29.1086C18.2878 29.1086 17.8776 29.512 17.8776 30.014V36.4547C17.8776 36.9549 18.288 37.3599 18.7943 37.3599Z",
    fill: "#FCDB7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4219 11.1948C11.7783 10.8379 11.7783 10.2585 11.4219 9.90134L6.82965 5.31017C6.47322 4.95325 5.89527 4.95325 5.53908 5.31017C5.18241 5.66709 5.18241 6.24362 5.53908 6.60054L10.1308 11.1946C10.4873 11.5486 11.0654 11.5486 11.4216 11.1946L11.4219 11.1948Z",
    fill: "#FCDB7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.05 31.83C32.4064 31.486 32.4064 30.9275 32.05 30.5862L27.4578 26.1577C27.1014 25.8136 26.5234 25.8136 26.167 26.1577C25.8106 26.5018 25.8106 27.0603 26.167 27.4016L30.7592 31.83C31.1156 32.1741 31.6938 32.1741 32.05 31.83Z",
    fill: "#FCDB7F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48047 18.5652C8.48047 18.0597 8.06398 17.6484 7.5502 17.6484H0.93029C0.416752 17.6484 2.28882e-05 18.0597 2.28882e-05 18.5652C2.28882e-05 19.0707 0.416752 19.482 0.93029 19.482H7.5502C8.06398 19.482 8.48047 19.0707 8.48047 18.5652Z",
    fill: "#FCDB7F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5889 18.5652C37.5889 18.0597 37.1835 17.6484 36.6836 17.6484H30.243C29.7429 17.6484 29.3377 18.0597 29.3377 18.5652C29.3377 19.0707 29.7431 19.482 30.243 19.482H36.6836C37.1837 19.482 37.5889 19.0707 37.5889 18.5652Z",
    fill: "#FCDB7F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4217 26.1577C11.0652 25.8136 10.487 25.8136 10.1308 26.1577L5.53908 30.5862C5.18241 30.9275 5.18241 31.486 5.53908 31.83C5.89551 32.1741 6.47346 32.1741 6.82966 31.83L11.4219 27.4016C11.7783 27.0603 11.7783 26.5018 11.4219 26.1577H11.4217Z",
    fill: "#FCDB7F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.05 5.31016C31.6936 4.95325 31.1154 4.95325 30.7592 5.31016L26.167 9.90116C25.8106 10.2581 25.8106 10.8374 26.167 11.1946C26.5237 11.5486 27.1016 11.5486 27.4578 11.1946L32.05 6.60072C32.4064 6.24381 32.4064 5.66731 32.05 5.3104V5.31016Z",
    fill: "#FCDB7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolP);
export default __webpack_public_path__ + "static/media/SolP.e26c4c5c4422072540b03506714d0861.svg";
export { ForwardRef as ReactComponent };